import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import type { input, output } from 'zod';

import type { DialogType } from '../../../../@types';
import { welcomeBonusCreateFormSchema, type WelcomeBonusCreateFormData } from '../../../../schema';
import FormModalLayout from '../../../layouts/FormModalLayout';
import {
  WelcomeBonusCampaignCreateFields,
  WelcomeBonusEligibilityCreateFields,
  WelcomeBonusProductCreateFields,
  WelcomeBonusRewardCreateFields,
  WelcomeBonusWageringCreateFields,
} from './WelcomeBonusCreateFields';
import { WelcomeBonusFormColumn, WelcomeBonusFormColumns } from './WelcomeBonusFormPrimitives';
import { getWelcomeBonusCreateDefaultValues } from './defaults';
import useWelcomeBonusCommands from './useWelcomeBonusCommands';
import { buildWelcomeBonusPayload } from './welcomeBonusAdapter';

const CreateWelcomeBonusForm = ({ closeModal }: DialogType) => {
  const { createWelcomeBonus } = useWelcomeBonusCommands();
  const form = useForm<
    input<typeof welcomeBonusCreateFormSchema>,
    unknown,
    output<typeof welcomeBonusCreateFormSchema>
  >({
    defaultValues: getWelcomeBonusCreateDefaultValues(),
    resolver: zodResolver(welcomeBonusCreateFormSchema),
  });

  const handleClose = () => {
    closeModal?.();
    form.reset(getWelcomeBonusCreateDefaultValues());
  };

  const onFormSubmit = (data: WelcomeBonusCreateFormData) => {
    createWelcomeBonus(buildWelcomeBonusPayload(data), handleClose);
  };

  return (
    <FormProvider {...form}>
      <FormModalLayout
        onSave={form.handleSubmit(onFormSubmit)}
        label='Add new welcome bonus'
        onClose={handleClose}
        showEditTabs={false}
      >
        <WelcomeBonusFormColumns>
          <WelcomeBonusFormColumn>
            <WelcomeBonusCampaignCreateFields />
            <WelcomeBonusEligibilityCreateFields />
          </WelcomeBonusFormColumn>
          <WelcomeBonusFormColumn>
            <WelcomeBonusRewardCreateFields />
            <WelcomeBonusProductCreateFields />
            <WelcomeBonusWageringCreateFields />
          </WelcomeBonusFormColumn>
        </WelcomeBonusFormColumns>
      </FormModalLayout>
    </FormProvider>
  );
};

export default CreateWelcomeBonusForm;
